export const PICKER_STYLES = {
  control: (base, state) => ({
    ...base,
    minHeight: 44,
    borderRadius: 10,
    borderColor: state.isFocused ? "var(--primary-500)" : "var(--neutral-275)",
    boxShadow: state.isFocused ? "0 0 0 3px color-mix(in srgb, var(--primary-500) 18%, transparent)" : "none",
    "&:hover": { borderColor: "var(--neutral-500)" },
  }),
  menu: (base) => ({ ...base, zIndex: 20, borderRadius: 12, overflow: "hidden" }),
  option: (base, state) => ({
    ...base,
    background: state.isFocused ? "var(--neutral-100)" : "var(--neutral-000)",
    color: "var(--neutral-900)",
  }),
  singleValue: (base) => ({ ...base, color: "var(--neutral-900)" }),
  placeholder: (base) => ({ ...base, color: "var(--neutral-500)" }),
  indicatorSeparator: () => ({ display: "none" }),
};
